import { render, staticRenderFns } from "./MatterReport.vue?vue&type=template&id=22ff2f3e&scoped=true"
import script from "./MatterReport.vue?vue&type=script&lang=js"
export * from "./MatterReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff2f3e",
  null
  
)

export default component.exports